export default __webpack_public_path__ + "static/media/default_profile.121af0a9.svg";